import React from 'react';

import { Container } from 'components/Container';
import { ExternalLink } from 'components/Links';
import { PageHeader } from 'components/PageHeader';
import { InfoTooltip } from 'components/Tooltip/InfoTooltip';

import { InventoryMissionControl } from './InventoryMissionControl';

export const InventoryMissionControlPage = () => (
  <Container>
    <PageHeader
      title={
        <InfoTooltip title="Recurrency Mission Control is the central dashboard for monitoring purchasing performance and current inventory status. All data on this page is filterable using the filters below.">
          Mission Control
        </InfoTooltip>
      }
      subtitle={
        <>
          Monitor performance and track trends. Learn more{' '}
          <ExternalLink to="https://help.recurrency.com/hc/en-us/articles/23271824431515-Inventory-Mission-Control-Overview">
            here
          </ExternalLink>
          .
        </>
      }
    />
    <InventoryMissionControl />
  </Container>
);
